<template>
  <div>
    <h5>
      {{ $t('lang.stores.schedule') }}
    </h5>

    <ScheduleBadge
      class="h6"
      :store="store"
      :search-params="searchParams"
      origin="details"
    />

    <div class="opening">
      <div class="row">
        <div
          v-if="formattedSchedule.length"
          class="col-md-12"
        >
          <ul>
            <div
              v-for="(availability, availabilityIndex) in formattedSchedule"
              :key="'availability_'+availabilityIndex"
              style="margin-bottom: 7px;"
            >
              <li
                v-for="(schedule, scheduleIndex) in availability.schedules"
                :key="'schedule_'+scheduleIndex"
              >
                <div v-if="scheduleIndex === 0">
                  <span v-if="availability.from === 'Monday' && availability.to === 'Sunday'">
                    {{ $t('lang.stores.days.everyday') }}
                  </span>
                  <span v-else>

                    {{ $t('lang.stores.days.'+ availability.from) }}
                    <span v-if="availability.from != availability.to">
                      - {{ $t('lang.stores.days.'+ availability.to) }}
                    </span>
                  </span>

                  <span class="hour">
                    {{ formatTime(schedule.open_hour, schedule.close_hour) }}
                  </span>
                </div>
                <div v-else>
                  &nbsp;<span class="hour">
                    {{ formatTime(schedule.open_hour, schedule.close_hour) }}
                  </span>
                </div>
              </li>
            </div>
          </ul>
        </div>
        <h6 v-else>
          {{ $t('lang.stores.schedule_empty') }}
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleBadge from '@/components/Store/ScheduleBadge.vue';

export default {
  name: 'StoreSchedule',
  components: { ScheduleBadge },
  props: {
    store: {
      type: Object,
      required: true,
    },
    fromBooking: {
      type: Boolean,
      default: false,
    },
    searchParams: {
      type: Object,
      required: false,
    },
  },

  computed: {

    formattedSchedule() {
      const { availabilities } = this.store;
      const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

      // Ordenar las disponibilidades por el orden de los días de la semana
      const sortedAvailabilities = availabilities.sort(
        (a, b) => daysOfWeek.indexOf(a.day) - daysOfWeek.indexOf(b.day),
      );

      // Formatear los horarios en un formato estándar
      const formatted = sortedAvailabilities.map((item) => ({
        day: item.day,
        schedules: item.schedules.map((schedule) => ({
          open_hour: schedule.open_hour,
          close_hour: schedule.close_hour,
        })),
      }));

      const result = [];
      let currentGroup = null;

      formatted.forEach((item, index) => {
        if (!currentGroup
            || JSON.stringify(currentGroup.schedules) !== JSON.stringify(item.schedules)
        ) {
          // Si los horarios no coinciden, iniciar un nuevo grupo
          if (currentGroup) {
            result.push(currentGroup);
          }
          currentGroup = {
            from: item.day,
            to: item.day,
            schedules: item.schedules,
          };
        } else {
          // Si los horarios coinciden, expandir el rango del grupo actual
          currentGroup.to = item.day;
        }

        // Si es el último día, cerrar el grupo
        if (index === formatted.length - 1) {
          result.push(currentGroup);
        }
      });

      return result;
    },
  },

  methods: {
    formatTime(open, close) {
      if (open === '00:00:00' && close === '23:59:00') {
        return '24H';
      }
      // 2000-01-01 HH:mm:ss
      let openHour = new Date((`2000-01-01 ${open}`).replace(/-/g, '/')); // Replace function needed to work on Safari
      let closeHour = new Date((`2000-01-01 ${close}`).replace(/-/g, '/')); // Replace function needed to work on Safari

      openHour = openHour.toLocaleTimeString('en', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: 'en',
      });
      closeHour = closeHour.toLocaleTimeString('en', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: 'en',
      });
      return `${openHour} - ${closeHour}`;
    },
  },
};
</script>
